import { useAuthStore } from "@/states";
import { AuthStoreType } from "@/states/auth";

export const useIsImpersonating = () => {
    const token = useAuthStore((state: AuthStoreType) => state.token);
    const authSnapshot = useAuthStore((state: AuthStoreType) => state.authSnapshot);

    if (!token || !authSnapshot) {
        return false;
    }
    return true;
};
